<template>
  <base-icon-button-menu-book :title="title"
                              @click="onClick"/>
</template>

<script>
  import BaseIconButtonMenuBook from '@/components/base-components/base-icons/BaseIconButtonMenuBook';

  export default {
    name: 'ActionOpenProposalFullDetails',
    components: { BaseIconButtonMenuBook },
    props: {
      proposal: {
        type: Object,
        required: true,
      },
      title: {
        type: String,
        default: 'Full details',
        validator: (value) => value.length > 0,
      },
    },
    computed: {
      onClick() {
        return this.$listeners.click || this.goToProposalHistory;
      },
    },
    methods: {
      goToProposalHistory() {
        const { document_specification } = this.proposal;
        const proposalId = this.getId(this.proposal);
        this.openProposalHistory(proposalId, document_specification.type);
      },
      openProposalHistory(id, infrastructure) {
        const routeResolve = this.$router.resolve({
          name: 'ProposalFullDetailsDashboard',
          params: { id, infrastructure },
        });
        window.open(routeResolve.href, '_blank');
      },
    },
  };
</script>

<style scoped>

</style>
